export const pascalCaseToSentence = (text: string) =>
  `${text.charAt(0)}${
    text
      .slice(1)
      .replace(/([A-Z])/g, ' $1') // Insert space before each uppercase letter
      .toLocaleLowerCase() // Convert the entire string to lowercase
  }`
